export default __webpack_public_path__ + "static/media/infoIcon.65fdb5dc.svg";